import React, { useState, useEffect } from "react";
import "./BuffetBookingPage.css";
import buffetVideo from "../assets/buffet-video.mp4";
import { Helmet } from "react-helmet";
// import stripeIcon from "../assets/stripe-icon.png";
// import stripeLogo from "../assets/stripe-logo.png";

const SLOTS = {
  1: { label: "Slot 1 (2–4pm)", start: "14:00", end: "16:00" },
  2: { label: "Slot 2 (4:30–6:30pm)", start: "16:30", end: "18:30" },
};

// Spinner overlay component
const SpinnerOverlay = () => (
  <div className="spinner-overlay">
    <div className="spinner"></div>
  </div>
);

const BuffetBookingPage = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [numAdults, setNumAdults] = useState(1);
  const [numChildren, setNumChildren] = useState(0);

  const [slots, setSlots] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [dateError, setDateError] = useState("");

  const getNextSunday = () => {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
    const nextSunday = new Date(now);
    nextSunday.setDate(now.getDate() + daysUntilSunday);
    const yyyy = nextSunday.getFullYear();
    const mm = String(nextSunday.getMonth() + 1).padStart(2, "0");
    const dd = String(nextSunday.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const fetchSlots = async (date) => {
    try {
      const res = await fetch(
        `/php/get-slot-availability.php?booking_date=${date}`
      );
      const data = await res.json();
      if (data.success) setSlots(data.slots);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => setBookingDate(getNextSunday()), []);
  useEffect(() => {
    if (bookingDate) fetchSlots(bookingDate);
  }, [bookingDate]);

  const handleDateChange = (e) => {
    const value = e.target.value;
    const [year, month, day] = value.split("-").map(Number);
    const chosen = new Date(year, month - 1, day);

    setBookingDate(value);

    if (chosen.getDay() !== 0) {
      setDateError("❌ Please select a Sunday.");
    } else {
      setDateError("");
    }
  };

  const handleBackToForm = () => {
    setBookingSuccess(false);
    setName("");
    setPhone("");
    setEmail("");
    setSelectedSlot("");
    setNumAdults(1);
    setNumChildren(0);
    setMessage("");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const selected = slots.find((s) => s.id === parseInt(selectedSlot));
    const totalPeople = numAdults + numChildren;

    if (selected && totalPeople > selected.remaining) {
      setMessage(
        `❌ Only ${selected.remaining} ${
          selected.remaining === 1 ? "slot is" : "slots are"
        } left for this time.`
      );
      return;
    }

    setLoading(true);
    const startTime = Date.now();

    try {
      const res = await fetch("/php/book-buffet.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          phone,
          email,
          booking_date: bookingDate,
          slot_id: selectedSlot,
          num_adults: numAdults,
          num_children: numChildren,
        }),
      });

      const data = await res.json();
      const elapsed = Date.now() - startTime;
      const remainingTime = 3000 - elapsed;

      setTimeout(
        () => {
          setLoading(false);
          if (data.success) {
            setBookingSuccess(true);
          } else {
            setMessage(data.message || "Booking failed.");
          }
        },
        remainingTime > 0 ? remainingTime : 0
      );
    } catch (err) {
      const elapsed = Date.now() - startTime;
      const remainingTime = 3000 - elapsed;
      setTimeout(
        () => {
          setLoading(false);
          setMessage("An error occurred. Please try again.");
        },
        remainingTime > 0 ? remainingTime : 0
      );
    }
  };

  const isSlotPast = (slotId, date) => {
    if (!date) return false;

    const today = new Date();
    const bookingDay = new Date(date);

    if (bookingDay > today) return false;

    if (bookingDay.toDateString() === today.toDateString() && SLOTS[slotId]) {
      const [hours, minutes] = SLOTS[slotId].end.split(":");
      const slotEndTime = new Date(bookingDay);
      slotEndTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);

      return today > slotEndTime;
    }

    return false;
  };

  return (
    <div className="page-container">
      <Helmet>
        <title>Buffet Bookings | LasGidi Restaurant</title>
        <meta
          name="description"
          content="Book your buffet experience at LasGidi Restaurant in Manchester. Enjoy an all-you-can-eat selection of authentic Nigerian dishes every Sunday."
        />
        <meta
          name="keywords"
          content="LasGidi Restaurant Buffet, Manchester Nigerian Buffet, All You Can Eat Nigerian Food, Buffet Booking Manchester, African Buffet"
        />
        <meta
          property="og:title"
          content="Buffet Bookings | LasGidi Restaurant"
        />
        <meta
          property="og:description"
          content="Reserve your spot for LasGidi Restaurant’s Sunday buffet. Authentic Nigerian meals served fresh in an all-you-can-eat experience."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="booking-container heading-container">
        <h1>Book a Buffet Slot</h1>
      </div>

      {bookingSuccess && (
        <div className="booking-success-container">
          <div className="success-box">
            <h2>🎉 Booking Confirmed!</h2>
            <p>
              <strong>Name:</strong> {name}
              <br />
              <strong>Date:</strong>{" "}
              {new Date(bookingDate).toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
              <br />
              <strong>Slot:</strong> {SLOTS[selectedSlot]?.label || "N/A"}
              <br />
              <strong>Adults:</strong> {numAdults}
              <br />
              <strong>Children:</strong> {numChildren}
            </p>
            <p>We can’t wait to welcome you!</p>
            <button className="post-review-btn" onClick={handleBackToForm}>
              Back
            </button>
          </div>
        </div>
      )}

      {/* Form + video */}
      {!bookingSuccess && (
        <div className="buffet-layout">
          <div className="video-section">
            <video
              src={buffetVideo}
              autoPlay
              muted
              loop
              playsInline
              className="background-video blurred"
            ></video>
            <video
              src={buffetVideo}
              autoPlay
              muted
              loop
              playsInline
              controls
              className="background-video main"
            ></video>
          </div>

          <div className="buffet-right">
            <div className="buffet-booking-container form-wrapper">
              <p>
                Reserve your spot for our Sunday buffet. Select your preferred
                date & time and join us for a delightful dining experience.
              </p>

              <form className="booking-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Booking Date:</label>
                  <input
                    type="date"
                    value={bookingDate}
                    min={getNextSunday()}
                    onChange={handleDateChange}
                    disabled={loading}
                  />
                  {dateError && <p className="error-message">{dateError}</p>}
                </div>

                <div className="form-group">
                  <label>Name:</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group flex-row">
                  <div>
                    <label>Phone Number:</label>
                    <input
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div>
                    <label>Email Address:</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Select Slot:</label>
                  <select
                    value={selectedSlot}
                    onChange={(e) => setSelectedSlot(e.target.value)}
                    onClick={() => fetchSlots(bookingDate)}
                    required
                    disabled={loading}
                  >
                    <option value="">-- Choose a Slot --</option>
                    {slots
                      .filter((s) => s.id !== 3)
                      .map((s) => {
                        const slot = SLOTS[s.id];
                        const full = s.remaining <= 0;
                        const past = isSlotPast(s.id, bookingDate);
                        return (
                          <option
                            key={s.id}
                            value={s.id}
                            disabled={full || past}
                          >
                            {slot?.label} {full ? "(Full)" : ""}{" "}
                            {past ? "(Over)" : ""}
                          </option>
                        );
                      })}
                  </select>
                </div>

                <div className="form-group flex-row">
                  <div>
                    <label>Number of Adults:</label>
                    <input
                      type="number"
                      min="1"
                      value={numAdults}
                      onChange={(e) => setNumAdults(parseInt(e.target.value))}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div>
                    <label>Number of Children:</label>
                    <input
                      type="number"
                      min="0"
                      value={numChildren}
                      onChange={(e) => setNumChildren(parseInt(e.target.value))}
                      disabled={loading}
                    />
                  </div>
                </div>

                {message && <p className="error-message">{message}</p>}

                <button
                  type="submit"
                  className="post-review-btn"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Booking"}
                </button>
              </form>

              {/* <div className="stripe-trust-badge">
                <span>Pay directly with</span>
                <img src={stripeLogo} alt="Stripe" className="stripe-logo" />
              </div>
              
              <div className="stripe-buttons">
                <button
                  className="custom-stripe-button adult-button"
                  onClick={() =>
                    window.open(
                      "https://buy.stripe.com/eVq14p7aBfA9gTU3sCfYY00",
                      "_blank"
                    )
                  }
                  disabled={loading}
                >
                <img
                  src={stripeIcon}
                  alt="Stripe Icon"
                  className="stripe-button-icon"
                />
                  Pay for Adults
                </button>
                <button
                  className="custom-stripe-button child-button"
                  onClick={() =>
                    window.open(
                      "https://buy.stripe.com/4gM8wRgLbds10UWgfofYY01",
                      "_blank"
                    )
                  }
                  disabled={loading}
                >
                <img
                  src={stripeIcon}
                  alt="Stripe Icon"
                  className="stripe-button-icon"
                />
                  Pay for Children
                </button>
              </div> */}

              {loading && <SpinnerOverlay />}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BuffetBookingPage;
